import { Container, Row } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';

import { HIDE_MAIN_MENU_ON_SELECTION_KEY } from '../../../../global/local-storage-constants';
import Heading from '@amzn/meridian/heading';
import Toggle from '@amzn/meridian/toggle';

const App = () => {
  const [hideMainMenuOnSelection, setHideMainMenuOnSelection] = useState(false);

  const flipValueOfToggle = (toggle, stateSetter, toggleLocalStorageKey) => {
    const toggleFlipValue = !toggle;
    const toggleFlipValueString = toggleFlipValue.toString();
    localStorage.setItem(toggleLocalStorageKey, toggleFlipValueString);
    stateSetter(toggleFlipValue);
  };

  const checkToggleInitialValueAndSetDefaultIfUndefined = (localStorageKey, stateSetter, defaultValue) => {
    const valueFromLocalStorageString = localStorage.getItem(localStorageKey);
    let valueFromLocalStorageBoolean =
      valueFromLocalStorageString === 'true' ? true : valueFromLocalStorageString === 'false' ? false : undefined;
    if (valueFromLocalStorageString === undefined || valueFromLocalStorageBoolean === undefined) {
      valueFromLocalStorageBoolean = defaultValue;
      localStorage.setItem(localStorageKey, valueFromLocalStorageBoolean.toString());
    }
    stateSetter(valueFromLocalStorageBoolean);
  };

  useEffect(() => {
    checkToggleInitialValueAndSetDefaultIfUndefined(HIDE_MAIN_MENU_ON_SELECTION_KEY, setHideMainMenuOnSelection, true);
  }, []);

  return (
    <Container fluid className="mt-3 ml-3">
      <Heading level={3} className="mt-4 mb-4">
        Settings
      </Heading>
      <hr />
      <Row className="ml-2 mr-2">
        <label className="mr-2">Automatically hide main menu when a menu item is selected </label>{' '}
        <Toggle
          checked={hideMainMenuOnSelection}
          onChange={() =>
            flipValueOfToggle(hideMainMenuOnSelection, setHideMainMenuOnSelection, HIDE_MAIN_MENU_ON_SELECTION_KEY)
          }
        ></Toggle>
      </Row>
      <hr />
    </Container>
  );
};

export default App;
